import React, { Component } from 'react';
import _ from 'lodash';

import * as QuizHelpers from '../../helpers/quiz';

class EmployeePreference extends Component {
  state = {
    animate: ''
  }

  componentDidMount () {
    const p = _.clone(this.props);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'Employee Preference');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleEmpPrefSelect (employeePref) {
    const { quiz, stepMethods } = _.clone(this.props);
    let nextStep = quiz.step + 1;
    this.props.reducer(employeePref);
    stepMethods.setStep(nextStep);
  }

  _prevStep () {
    window.history.go(-1);
  }

  render () {
    return (
      <section className={'p30 text-center animate ' + this.state.animate}>
        <div className='wrap'>
          <h3>Which of these options would you and your employees&nbsp;prefer?</h3>
          <p className='form radio two'>
            <input
              type='radio'
              name='employee-budget'
              value='high'
              id='employee-high'
            /><label
              htmlFor='employee-high'
              onClick={(e) => this._handleEmpPrefSelect(2)}><strong>Lower, more predictable costs when receiving care</strong>, even if it means a higher monthly payment.</label>
            <input
              type='radio'
              name='employee-budget'
              value='low'
              id='employee-low'
            /><label
              htmlFor='employee-low'
              onClick={(e) => this._handleEmpPrefSelect(1)}>A <strong>lower monthly payment</strong> even if it means paying more when receiving&nbsp;care.</label>
          </p>
          <p>Not sure? You can use this <a href='/pdf/CDPHP_Sample-Employee-Survey.pdf' target='_blank'
          >employee survey</a> to anonymously ask employees about their priorities and preferences.</p>
          <button
            className='btn back'
            onClick={this._prevStep}>Previous</button>
        </div>
      </section>
    );
  }
}

export default EmployeePreference;



// WEBPACK FOOTER //
// ./src/components/Questions/EmployeePreference.jsx